// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__35ipB","subheader":"ReorderModal_subheader__O-Ksb","listWrap":"ReorderModal_listWrap__1oOF_"};